var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToGroupSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.03333 8.23333L4.18889 9.38889L6.78889 6.78889M4.18889 4.18889V2.57111C4.18889 1.92394 4.18889 1.60035 4.31484 1.35317C4.42563 1.13574 4.6024 0.95896 4.81984 0.848171C5.06702 0.722222 5.39061 0.722222 6.03778 0.722222H10.4289C11.0761 0.722222 11.3996 0.722222 11.6468 0.848171C11.8642 0.95896 12.041 1.13574 12.1518 1.35317C12.2778 1.60035 12.2778 1.92394 12.2778 2.57111V6.96222C12.2778 7.60941 12.2778 7.93296 12.1518 8.18018C12.041 8.39757 11.8642 8.57437 11.6468 8.68516C11.3996 8.81111 11.0761 8.81111 10.4289 8.81111H8.81111M2.57111 12.2778H6.96222C7.60941 12.2778 7.93296 12.2778 8.18018 12.1518C8.39757 12.041 8.57437 11.8642 8.68516 11.6468C8.81111 11.3996 8.81111 11.0761 8.81111 10.4289V6.03778C8.81111 5.39061 8.81111 5.06702 8.68516 4.81984C8.57437 4.6024 8.39757 4.42563 8.18018 4.31484C7.93296 4.18889 7.60941 4.18889 6.96222 4.18889H2.57111C1.92394 4.18889 1.60035 4.18889 1.35317 4.31484C1.13574 4.42563 0.95896 4.6024 0.848171 4.81984C0.722222 5.06702 0.722222 5.39061 0.722222 6.03778V10.4289C0.722222 11.0761 0.722222 11.3996 0.848171 11.6468C0.95896 11.8642 1.13574 12.041 1.35317 12.1518C1.60035 12.2778 1.92394 12.2778 2.57111 12.2778Z",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToGroupSm);
export default __webpack_public_path__ + "static/media/add-to-group-sm.e682eb8d9beccb3374f6870fc6f3d904.svg";
export { ForwardRef as ReactComponent };